export default __webpack_public_path__ + "static/media/cheer.211b19d2.svg";